// Vendor
import React from 'react';

// Components
import Gap from 'src/components/atoms/Gap';
import { Row } from 'src/components/atoms/Row';
import Text, { TextVariant } from 'src/components/atoms/Text';
import { StyledCol } from './styles';

// Enums
import { ProofResultPassFail } from 'src/ts/enums';
import { startCase } from 'src/features/fdeInbox/helpers/transformTextToReadable';

const ReportDetailsSection: React.FC = () => {
  const cleanLabel = startCase(ProofResultPassFail.CLEAN.toLowerCase());
  const editedLabel = startCase(ProofResultPassFail.EDITED.toLowerCase());

  return (
    <section>
      <Text variant={TextVariant.h3}>Details</Text>
      <Gap height={1.5} />
      <Row gap={2}>
        <StyledCol alignContent="left">
          <Text>This report will contain:</Text>
          <ul>
            <li>Lifetime total applicants</li>
            <li>Lifetime reviewed applicants</li>
            <li>Lifetime {cleanLabel} applicants</li>
            <li>Lifetime {cleanLabel} rate</li>
            <li>Lifetime {editedLabel} applicants</li>
            <li>Lifetime {editedLabel} rate</li>
          </ul>
        </StyledCol>
        <StyledCol>
          <Text>Plus for selected companies or properties:</Text>
          <ul>
            <li>Total number {cleanLabel}</li>
            <li>{cleanLabel} rate</li>
            <li>Total number {editedLabel}</li>
            <li>{editedLabel} rate</li>
          </ul>
        </StyledCol>
      </Row>
    </section>
  );
};

export default ReportDetailsSection;
